// src/pages/MentionLegalesPage.tsx

import { Link } from "react-router";
import { CONTACT_EMAIL } from "../constants/config";
import PageMeta from "../components/PageMeta";

export default function MentionLegalesPage() {
  return (
    <>
      <PageMeta
        title="Mentions légales — Crush Emploi"
        description="Mentions légales du site Crush Emploi : éditeur, hébergement, propriété intellectuelle et données personnelles."
        path="/mentions-legales"
      />
    <main className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold">Mentions Légales</h1>
        <Link
          to="/"
          className="text-white p-2 rounded-lg bg-gray-600 hover:bg-gray-500 transition"
        >
          Retour
        </Link>
      </div>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Éditeur du site</h2>
        <p>
          <strong>Nom du responsable :</strong> Crush Emploi
        </p>
        <p>
          <strong>Adresse :</strong> Paris 75013, France
        </p>
        <p>
          <strong>Email :</strong>{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-blue-600 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Hébergement</h2>
        <p>
          <strong>Hébergeur :</strong> Vercel Inc.
        </p>
        <p>
          <strong>Adresse :</strong> 440 N Barranca Ave #4133, Covina, CA 91723,
          USA
        </p>
        <p>
          <strong>Site web :</strong>{" "}
          <a
            href="https://vercel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            https://vercel.com
          </a>
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          3. Propriété intellectuelle
        </h2>
        <p>
          L'ensemble du contenu (textes, images, logos, éléments graphiques) de
          ce site est la propriété exclusive de <strong>Crush Emploi</strong>.
          Toute reproduction, représentation, modification ou utilisation, en
          tout ou partie, sans autorisation écrite est strictement interdite.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Responsabilité</h2>
        <p>
          Crush Emploi s'efforce d'assurer l'exactitude et la mise à jour des
          informations diffusées. Toutefois, aucune garantie n’est donnée quant
          à leur exhaustivité ou leur exactitude. L’utilisation du site se fait
          sous la seule responsabilité de l’utilisateur.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Données personnelles</h2>
        <p>
          Les informations collectées via le formulaire (adresse e-mail) sont
          destinées exclusivement à l’envoi d’informations concernant la
          disponibilité de l’application Crush Emploi. Conformément à la loi
          "Informatique et Libertés", vous pouvez exercer votre droit d’accès,
          de rectification et de suppression de vos données à tout moment en
          nous contactant à :{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-blue-600 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Cookies</h2>
        <p>
          Le site peut utiliser des cookies à des fins de mesure d’audience ou
          de fonctionnement. Vous pouvez refuser leur utilisation via les
          paramètres de votre navigateur.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">7. Loi applicable</h2>
        <p>
          Les présentes mentions légales sont régies par le droit français. En
          cas de litige, les tribunaux français seront seuls compétents.
        </p>
      </section>
    </main>
    </>
  );
}
